export default [
  {
    extension: "Marketing automation",
    status: "Out for delivery",
    price: "₹499",
    action: "Review"
  },
  {
    extension: "Whatsapp web",
    status: "Dispatched",
    price: "₹499",
    action: "Add to cart"
  },
  {
    extension: "Supply Chain Management",
    status: "Out for delivery",
    price: "₹499",
    action: "Review"
  },
  {
    extension: "CRM",
    status: "Delivered",
    price: "₹499",
    action: "Add to cart"
  }
];
